// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--LZE0a";
export var footer__contact = "Footer-module--footer__contact--Gi1uw";
export var footer__contact__logo = "Footer-module--footer__contact__logo--Jeae8";
export var footer__navigation = "Footer-module--footer__navigation--C1ujK";
export var footer__copyright = "Footer-module--footer__copyright--Kr5rb";